<template>
    <div :style="styles" class="smooth">
        <v-card  class="summarycard ml-1 mt-8 ">
            <v-card-title style="padding:20px;" class="tableheader">{{ title || 'Selected Packs' }}</v-card-title>
            <v-card-text>
            <div v-for="(pack, idx) in selectedPacks" :key="idx">
                <v-divider style="margin: 0"/>
                <div class="summary-pack d-flex">
                <div class="name">
                    <div>{{ pack.planName }}</div>
                    <div class="channel">{{ pack.channelCount }} Channels</div>
                </div>
                <div class="price">
                  <span class="rupee-big">&#8377;</span>
                  {{ $toFixed((parseFloat(pack.tariff) + pack.ncfPrice) * 1.18) }}
                  
                  <span class="raw">  /Month</span></div>
                </div>
            </div>
            <v-divider style="margin-top: 0"/>
            <div class="summary_item">
                <div class="head">Subscription Amount</div>
                
                <div class="value"><span class="rupee">&#8377;</span>{{ $toFixed(subscriptionAmount) }}</div>
            </div>
            <div class="summary_item">
                <div class="head">NCF Amount</div>
                <div class="value"><span class="rupee">&#8377;</span>{{ ncfAmount }}</div>
            </div>
            <div class="summary_item">
                <div class="head">GST</div>
                <div class="value"><span class="rupee">&#8377;</span>{{ $toFixed((subscriptionAmount + ncfAmount) * 0.18, 2) }}</div>
            </div>
            <v-divider />
            <div class="summary_item">
                <div class="head">Total Amount</div>
                <div class="value">
                <span class="rupee">&#8377;</span>{{
                    parseFloat(
                        (subscriptionAmount + ncfAmount) * 1.18
                    ).toFixed(2)
                }}
                </div>
            </div>
            </v-card-text>
            <v-card-actions class="mt-8">
              <v-spacer></v-spacer>
              <Button
                class=" mr-4 mb-3"
                color="primary"
                @click="() => this.$emit('click')"
                :label="buttonText || 'Checkout'"
                v-if="!loading"
              />
              <v-progress-circular v-else indeterminate />
            </v-card-actions>
        </v-card>
        </div>
</template>

<style lang="sass" scoped>
  .name
    width: 150px
  .summary_item
    display: flex
    .head
      flex: 1
      text-align: right
      padding: 0 10px
      font-weight: 700
    .value
      width: 80px
      margin-right: 20px
      padding: 0 10px 0 10px
      position: relative
    .rupee
      right: 0
  .v-card__text
    padding-left: 0
    padding-right: 0
  .smooth
    transition: width 0.2s ease
  .summary-pack
    padding: 10px 0
    .name
      padding-left: 10px
      font-weight: 700
      color: #333
      flex-grow: 1
      .channel
        font-weight: 700
        color: #79166a
    .price
      padding-right: 10px
      font-size: 20px
      font-weight: 700
      padding-top: 10px
      .raw
        font-size: 14px
        font-weight: 400
        </style>

<script>
import Button from '../../components/Elements/Button.vue';
export default {
    props: {
      title: String,
      buttonText: String,
      selectedPacks: Array,
      subscriptionAmount: Number,
      ncfAmount: Number,
      addPlan: Function,
      loading: Boolean,
      styles: Object
    },
    components: {
      Button
    }
}
</script>
<style scoped>
.summarycard {
  margin-right: 1rem !important;
  
}
</style>
